import Preloader from './Preloader';

/**
 * Cobre a tela inteira enquanto o servidor trabalha.
 *
 * Ler a exportação do Compumate leva alguns segundos — são mais de cem itens
 * do ERP virando linhas de cotação, com o banco no servidor. Sem isto o
 * comprador fica olhando uma tela parada, sem saber se clicou, e clica de novo.
 */
export default function TelaProcessando({ titulo, detalhe }: { titulo: string; detalhe?: string }) {
  return (
    <div
      role="alertdialog"
      aria-live="assertive"
      aria-busy="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-dominant/85 backdrop-blur-sm px-md"
    >
      <div className="flex w-full max-w-[360px] flex-col items-center gap-md rounded-xl border border-border bg-surface px-lg py-xl text-center shadow-lg">
        <Preloader tamanho="sm" className="mb-xs" />
        <p className="text-[15px] font-bold text-ink">{titulo}</p>
        {detalhe && <p className="text-[13px] leading-snug text-muted">{detalhe}</p>}
      </div>
    </div>
  );
}
